import { useState, useEffect, useRef } from "react";
import "@/App.css";
import axios from "axios";
import { motion, useScroll, useTransform } from "framer-motion";
import {
  Wrench,
  PaintBrush,
  Sparkle,
  Drop,
  Lightning,
  Wind,
  Fire,
  Bathtub,
  Phone,
  EnvelopeSimple,
  MapPin,
  List,
  X,
  FacebookLogo,
  InstagramLogo,
  CheckCircle,
  Clock,
  CurrencyDollar,
  Users,
  ThumbsUp,
  Handshake,
} from "@phosphor-icons/react";
import { Button } from "./components/ui/button";
import { Input } from "./components/ui/input";
import { Textarea } from "./components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./components/ui/select";
import { Toaster, toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Company data
const COMPANY = {
  name: "MSC MULTISERVICES",
  tagline: "Reliable. Professional. Affordable.",
  phone: "954-278-7275",
  email: "Salesmgr@mscmultiservices.com",
  address: "2239 NW 65th Ave Margate, FL 33063",
  website: "www.mscmultiservices.com",
  logo: "https://customer-assets.emergentagent.com/job_542df1c1-4b1f-4a85-9c99-392eb88d5de6/artifacts/tvp8tkca_MSC%20LOGO.png",
};

const SERVICES = [
  { name: "Remodeling", icon: Wrench, description: "Complete home transformations", image: "https://images.unsplash.com/photo-1772567732969-c1506edf80a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxraXRjaGVuJTIwcmVtb2RlbGluZyUyMG1vZGVybiUyMHJlbm92YXRpb258ZW58MHx8fHwxNzc2MTk0NDYzfDA&ixlib=rb-4.1.0&q=85" },
  { name: "Painting", icon: PaintBrush, description: "Interior & exterior painting", image: "https://images.unsplash.com/photo-1688372198189-de6a51777a81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxtYW4lMjBwYWludGluZyUyMHdhbGwlMjByb2xsZXIlMjBob21lJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3NzYxOTUxOTd8MA&ixlib=rb-4.1.0&q=85" },
  { name: "Cleaning", icon: Sparkle, description: "Deep cleaning services", image: "https://images.pexels.com/photos/4239035/pexels-photo-4239035.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Plumbing", icon: Drop, description: "All plumbing repairs", image: "https://images.unsplash.com/photo-1676210134190-3f2c0d5cf58d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwbHVtYmVyJTIwc2luayUyMHJlcGFpcnxlbnwwfHx8fDE3NzYxOTQ0NjJ8MA&ixlib=rb-4.1.0&q=85" },
  { name: "Electrical", icon: Lightning, description: "Electrical installations", image: "https://images.unsplash.com/photo-1583275477830-7e8e9d56d15f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMGluc3RhbGxpbmclMjBsaWdodCUyMGZpeHR1cmV8ZW58MHx8fHwxNzc2MTk0NDYyfDA&ixlib=rb-4.1.0&q=85" },
  { name: "A/C Installation", icon: Wind, description: "HVAC services", image: "https://images.unsplash.com/photo-1766201926837-6b8cb0383de8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxhYyUyMHVuaXQlMjBtYWludGVuYW5jZSUyMG91dGRvb3IlMjBjb21wcmVzc29yfGVufDB8fHx8MTc3NjE5NTIwNXww&ixlib=rb-4.1.0&q=85" },
  { name: "Water Heaters", icon: Fire, description: "Installation & repair", image: "https://images.unsplash.com/photo-1620653713380-7a34b773fef8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHx3YXRlciUyMGhlYXRlciUyMHRhbmslMjBpbnN0YWxsYXRpb24lMjBwbHVtYmVyfGVufDB8fHx8MTc3NjE5NDQ2Mnww&ixlib=rb-4.1.0&q=85" },
  { name: "Bathtubs", icon: Bathtub, description: "Tub installations", image: "https://images.unsplash.com/photo-1758548157466-7c454382035a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiYXRocm9vbSUyMGJhdGh0dWIlMjBsdXh1cnklMjB3aGl0ZXxlbnwwfHx8fDE3NzYxOTQ0NjN8MA&ixlib=rb-4.1.0&q=85" },
];

const WHY_CHOOSE_US = [
  { title: "Fast Response", icon: Clock, number: "01" },
  { title: "Competitive Pricing", icon: CurrencyDollar, number: "02" },
  { title: "Experienced Team", icon: Users, number: "03" },
  { title: "Quality Guaranteed", icon: ThumbsUp, number: "04" },
  { title: "Customer First", icon: Handshake, number: "05" },
];

const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/542df1c1-4b1f-4a85-9c99-392eb88d5de6/images/3ceeabc03136f32b75169601e9db19c9e7f01c4c972b6a2ca9b725f9382e9191.png",
  parallax: "https://static.prod-images.emergentagent.com/jobs/542df1c1-4b1f-4a85-9c99-392eb88d5de6/images/ed56b0e19139ed0bb40a40724e3d4228abe49b66a05e5f00259c62b7ef91e742.png",
};

// Header Component
const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", href: "#hero" },
    { name: "About", href: "#about" },
    { name: "Services", href: "#services" },
    { name: "Why Us", href: "#why-us" },
    { name: "Contact", href: "#contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "glass-header shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-24 sm:h-28">
          {/* Logo */}
          <a href="#" data-testid="header-logo" className="flex items-center">
            <div className={`transition-all duration-300 ${!isScrolled ? 'bg-white/90 backdrop-blur-sm rounded-lg p-2' : ''}`}>
              <img
                src={COMPANY.logo}
                alt={COMPANY.name}
                className="h-16 sm:h-20 w-auto"
              />
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                data-testid={`nav-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`nav-link text-sm ${
                  isScrolled ? "text-[#0A1C3B]" : "text-white"
                }`}
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href={`tel:${COMPANY.phone}`}
              data-testid="header-call-btn"
              className={`flex items-center gap-2 text-sm font-medium ${
                isScrolled ? "text-[#0A1C3B]" : "text-white"
              }`}
            >
              <Phone size={18} weight="fill" />
              {COMPANY.phone}
            </a>
            <a
              href="#contact"
              data-testid="header-request-service-btn"
              className="btn-primary px-5 py-2.5 rounded text-sm font-medium"
            >
              Request Service
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-btn"
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X size={28} className={isScrolled ? "text-[#0A1C3B]" : "text-white"} />
            ) : (
              <List size={28} className={isScrolled ? "text-[#0A1C3B]" : "text-white"} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden fixed inset-0 top-20 bg-white z-40 transform transition-transform duration-300 ${
          mobileMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <nav className="flex flex-col p-6 gap-4">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              data-testid={`mobile-nav-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
              className="text-lg font-medium text-[#0A1C3B] py-3 border-b border-gray-100"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <a
            href={`tel:${COMPANY.phone}`}
            data-testid="mobile-call-btn"
            className="flex items-center gap-2 text-lg font-medium text-[#2563EB] py-3"
          >
            <Phone size={24} weight="fill" />
            {COMPANY.phone}
          </a>
          <a
            href="#contact"
            data-testid="mobile-request-btn"
            className="btn-primary px-6 py-3 rounded text-center font-medium mt-4"
            onClick={() => setMobileMenuOpen(false)}
          >
            Request Service
          </a>
        </nav>
      </div>
    </header>
  );
};

// Hero Section with Parallax
const HeroSection = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "30%"]);

  return (
    <section
      ref={ref}
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Parallax Background */}
      <motion.div
        style={{ y }}
        className="absolute inset-0 w-full h-[120%]"
      >
        <img
          src={IMAGES.hero}
          alt="Modern apartment interior"
          className="w-full h-full object-cover"
        />
      </motion.div>

      {/* Overlay */}
      <div className="hero-overlay absolute inset-0" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="max-w-2xl"
        >
          <h1 className="text-5xl sm:text-6xl lg:text-7xl text-white font-medium tracking-tight mb-6 text-shadow">
            {COMPANY.tagline}
          </h1>
          <p className="text-lg text-gray-200 mb-8 leading-relaxed">
            MSC Multiservices delivers reliable, high-quality, and efficient
            solutions for property managers and homeowners throughout South
            Florida.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              data-testid="hero-request-service-btn"
              className="btn-primary px-8 py-4 rounded text-lg font-medium inline-flex items-center justify-center"
            >
              Request Service
            </a>
            <a
              href={`tel:${COMPANY.phone}`}
              data-testid="hero-call-btn"
              className="btn-outline px-8 py-4 rounded text-lg font-medium inline-flex items-center justify-center gap-2"
            >
              <Phone size={22} weight="fill" />
              Call Now
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
            className="w-1.5 h-3 bg-white/70 rounded-full mt-2"
          />
        </div>
      </motion.div>
    </section>
  );
};

// About Section with Bento Grid
const AboutSection = () => {
  return (
    <section id="about" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-[#2563EB] text-xs tracking-[0.2em] uppercase font-bold mb-4">
            Who We Are
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-[#0A1C3B] font-medium tracking-tight">
            Building Trust, One Property at a Time
          </h2>
        </motion.div>

        {/* About Grid - 3 equal columns */}
        <div className="grid md:grid-cols-3 gap-6">
          {/* About Us */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="bg-[#0A1C3B] rounded-lg p-8"
            data-testid="about-card"
          >
            <h3 className="text-2xl text-white font-medium mb-4">
              About Us
            </h3>
            <p className="text-gray-300 leading-relaxed">
              MSC Multiservices is a trusted company specializing in apartment
              repairs, remodeling, and property maintenance. We deliver reliable,
              high-quality, and efficient solutions tailored for property managers
              and homeowners.
            </p>
          </motion.div>

          {/* Mission */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-[#F8F9FA] rounded-lg p-8"
            data-testid="mission-card"
          >
            <h3 className="text-2xl text-[#0A1C3B] font-medium mb-4">Our Mission</h3>
            <p className="text-[#64748B] leading-relaxed">
              To provide professional, dependable, and high-quality services that
              enhance property value and exceed customer expectations.
            </p>
          </motion.div>

          {/* Vision */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="bg-[#2563EB] rounded-lg p-8"
            data-testid="vision-card"
          >
            <h3 className="text-2xl text-white font-medium mb-4">Our Vision</h3>
            <p className="text-blue-100 leading-relaxed">
              To become a leading property service company recognized for
              excellence, trust, and consistent results.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Services Section
const ServicesSection = () => {
  return (
    <section id="services" className="py-24 sm:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-[#0A1C3B] font-medium tracking-tight mb-4">
            Quality Services You Can Trust
          </h2>
          <p className="text-lg text-[#2563EB] tracking-wide mb-6">
            painting. cleaning. repairs.
          </p>
          <p className="text-[#64748B] text-lg max-w-2xl mx-auto leading-relaxed">
            From small repairs to complete renovations, our experienced team delivers professional results 
            that exceed expectations. We take pride in every project, big or small.
          </p>
        </motion.div>

        <div className="services-grid">
          {SERVICES.map((service, index) => (
            <motion.div
              key={service.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="service-card bg-white rounded-lg overflow-hidden cursor-pointer group"
              data-testid={`service-${service.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="h-40 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="text-lg font-medium text-[#0A1C3B] mb-1">
                  {service.name}
                </h3>
                <p className="text-sm text-[#64748B]">{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Parallax Divider
const ParallaxDivider = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-20%", "20%"]);

  return (
    <section ref={ref} className="relative h-[50vh] overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0 w-full h-[140%]">
        <img
          src={IMAGES.parallax}
          alt="Modern bathroom remodel"
          className="w-full h-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-[#0A1C3B]/70" />
      <div className="relative z-10 h-full flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="text-center px-6"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-white font-medium tracking-tight text-shadow">
            Transform Your Space Today
          </h2>
          <p className="text-gray-300 text-lg mt-4 max-w-2xl mx-auto">
            From small repairs to complete renovations, we handle it all.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

// Why Choose Us Section with Parallax
const WhyChooseUsSection = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);

  return (
    <section ref={ref} id="why-us" className="relative min-h-[80vh] overflow-hidden flex items-center">
      {/* Parallax Background */}
      <motion.div style={{ y }} className="absolute inset-0 w-full h-[130%]">
        <div 
          className="w-full h-full bg-cover bg-center"
          style={{ 
            backgroundImage: `url(${IMAGES.parallax})`,
          }}
        />
      </motion.div>
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-[#050A15]/90" />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-24 sm:py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Title */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-[#2563EB] text-xs tracking-[0.2em] uppercase font-bold mb-4">
              The MSC Difference
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl text-white font-medium tracking-tight mb-6">
              Why Choose Us
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              We're committed to delivering exceptional service on every project. Here's what sets us apart from the competition.
            </p>
          </motion.div>

          {/* Right: List */}
          <div className="space-y-0">
            {WHY_CHOOSE_US.map((item, index) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex items-center gap-5 py-5 border-b border-white/10 group"
                data-testid={`why-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="flex-shrink-0 w-14 h-14 bg-[#2563EB]/10 rounded-lg flex items-center justify-center group-hover:bg-[#2563EB]/20 transition-colors">
                  <item.icon size={28} className="text-[#2563EB]" weight="duotone" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-medium text-white group-hover:text-[#2563EB] transition-colors">
                    {item.title}
                  </h3>
                </div>
                <CheckCircle size={24} className="text-[#2563EB]/50" weight="fill" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleServiceChange = (value) => {
    setFormData((prev) => ({ ...prev, service: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API}/contact`, formData);
      toast.success("Thank you! We'll be in touch soon.", {
        description: "Your service request has been submitted.",
      });
      setFormData({
        name: "",
        email: "",
        phone: "",
        service: "",
        message: "",
      });
    } catch (error) {
      toast.error("Something went wrong", {
        description: "Please try again or call us directly.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="contact-split">
          {/* Form Side */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-[#2563EB] text-xs tracking-[0.2em] uppercase font-bold mb-4">
              Get In Touch
            </p>
            <h2 className="text-3xl sm:text-4xl text-[#0A1C3B] font-medium tracking-tight mb-8">
              Request Service
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label className="form-label">Full Name *</label>
                  <Input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="John Doe"
                    data-testid="contact-name-input"
                    className="rounded-sm"
                  />
                </div>
                <div>
                  <label className="form-label">Email *</label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="john@example.com"
                    data-testid="contact-email-input"
                    className="rounded-sm"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label className="form-label">Phone Number</label>
                  <Input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="(555) 123-4567"
                    data-testid="contact-phone-input"
                    className="rounded-sm"
                  />
                </div>
                <div>
                  <label className="form-label">Service Needed</label>
                  <Select value={formData.service} onValueChange={handleServiceChange}>
                    <SelectTrigger data-testid="contact-service-select" className="rounded-sm">
                      <SelectValue placeholder="Select a service" />
                    </SelectTrigger>
                    <SelectContent>
                      {SERVICES.map((service) => (
                        <SelectItem key={service.name} value={service.name}>
                          {service.name}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              </div>

              <div>
                <label className="form-label">Message *</label>
                <Textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us about your project..."
                  rows={5}
                  data-testid="contact-message-input"
                  className="rounded-sm"
                />
              </div>

              <Button
                type="submit"
                disabled={isSubmitting}
                data-testid="contact-submit-btn"
                className="w-full sm:w-auto bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-8 py-3 rounded-sm text-lg font-medium transition-all hover:-translate-y-0.5"
              >
                {isSubmitting ? "Sending..." : "Request Service"}
              </Button>
            </form>
          </motion.div>

          {/* Contact Info Side */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col justify-center"
          >
            <div className="bg-[#0A1C3B] rounded-lg p-8 lg:p-12">
              <h3 className="text-2xl text-white font-medium mb-8">
                Contact Information
              </h3>

              <div className="space-y-6">
                <a
                  href={`tel:${COMPANY.phone}`}
                  data-testid="contact-phone-link"
                  className="flex items-center gap-4 text-gray-300 hover:text-white transition-colors"
                >
                  <div className="w-12 h-12 bg-[#2563EB]/20 rounded-lg flex items-center justify-center">
                    <Phone size={24} className="text-[#2563EB]" weight="fill" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Phone</p>
                    <p className="text-lg font-medium">{COMPANY.phone}</p>
                  </div>
                </a>

                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="contact-email-link"
                  className="flex items-center gap-4 text-gray-300 hover:text-white transition-colors"
                >
                  <div className="w-12 h-12 bg-[#2563EB]/20 rounded-lg flex items-center justify-center">
                    <EnvelopeSimple size={24} className="text-[#2563EB]" weight="fill" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Email</p>
                    <p className="text-lg font-medium">{COMPANY.email}</p>
                  </div>
                </a>

                <div className="flex items-start gap-4 text-gray-300">
                  <div className="w-12 h-12 bg-[#2563EB]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin size={24} className="text-[#2563EB]" weight="fill" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Address</p>
                    <p className="text-lg font-medium">{COMPANY.address}</p>
                  </div>
                </div>
              </div>

              <div className="mt-10 pt-8 border-t border-white/10">
                <p className="text-sm text-gray-400 mb-4">Business Hours</p>
                <p className="text-gray-300">Monday - Saturday: 8:00 AM - 6:00 PM</p>
                <p className="text-gray-300">Sunday: Closed</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Footer Component
const Footer = () => {
  return (
    <footer className="bg-[#0A1C3B] py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Tagline */}
          <div className="lg:col-span-2">
            <img
              src={COMPANY.logo}
              alt={COMPANY.name}
              className="h-16 w-auto mb-6"
            />
            <p className="text-2xl text-white font-medium mb-4">
              {COMPANY.tagline}
            </p>
            <p className="text-gray-400 max-w-md">
              Your trusted partner for property maintenance and remodeling
              services in South Florida.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-medium text-white mb-6">Quick Links</h4>
            <nav className="space-y-3">
              <a
                href="#about"
                data-testid="footer-about-link"
                className="block text-gray-400 hover:text-[#2563EB] transition-colors"
              >
                About Us
              </a>
              <a
                href="#services"
                data-testid="footer-services-link"
                className="block text-gray-400 hover:text-[#2563EB] transition-colors"
              >
                Services
              </a>
              <a
                href="#why-us"
                data-testid="footer-why-us-link"
                className="block text-gray-400 hover:text-[#2563EB] transition-colors"
              >
                Why Choose Us
              </a>
              <a
                href="#contact"
                data-testid="footer-contact-link"
                className="block text-gray-400 hover:text-[#2563EB] transition-colors"
              >
                Contact
              </a>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-medium text-white mb-6">Contact Us</h4>
            <div className="space-y-3 text-gray-400">
              <a
                href={`tel:${COMPANY.phone}`}
                data-testid="footer-phone-link"
                className="block hover:text-[#2563EB] transition-colors"
              >
                {COMPANY.phone}
              </a>
              <p>{COMPANY.address}</p>
              <a
                href={`https://${COMPANY.website}`}
                data-testid="footer-website-link"
                className="block hover:text-[#2563EB] transition-colors"
              >
                {COMPANY.website}
              </a>
            </div>

            {/* Social Links */}
            <div className="flex gap-3 mt-6">
              <a
                href="https://www.facebook.com/share/1DNBueYPQD/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                className="social-icon"
                aria-label="Facebook"
              >
                <FacebookLogo size={20} weight="fill" />
              </a>
              <a
                href="https://www.instagram.com/mscmultiservices?igsh=ajV3ejRjNTc2enp3"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="social-icon"
                aria-label="Instagram"
              >
                <InstagramLogo size={20} weight="fill" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            Design & Developed by{" "}
            <a 
              href="https://www.dplus.ai" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#2563EB] hover:text-white transition-colors"
            >
              Design Plus
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

// Floating Call Button
const FloatingCallButton = () => {
  return (
    <a
      href={`tel:${COMPANY.phone}`}
      data-testid="floating-call-btn"
      className="floating-phone flex items-center justify-center w-14 h-14 bg-[#2563EB] rounded-full shadow-lg hover:bg-[#1D4ED8] transition-colors md:hidden"
      aria-label="Call us"
    >
      <Phone size={24} className="text-white" weight="fill" />
    </a>
  );
};

// Main App Component
function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ParallaxDivider />
        <WhyChooseUsSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingCallButton />
    </div>
  );
}

export default App;
